import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { FeatureFlags } from "feature-flags";
// import { IMutableContext, UnleashClient } from "unleash-proxy-client";


@Injectable({
  providedIn: "root",
})
export class FeatureFlagService {
  public unleash = new window["unleash"].UnleashClient({
    url: environment.unleash.proxyUrl,
    clientKey: environment.unleash.clientKey,
    refreshInterval: environment.unleash.refreshInterval,
    appName: environment.unleash.appName,
    environment: environment.unleash.environment,
    fetch: async (input: RequestInfo, init: RequestInit) => {
      console.log("UNLEASH fetch", input, init);
      return fetch(input, {
        ...init,
        cache: 'no-store', // Disabilita la cache
        headers: {
          ...init.headers,
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
    },
  });

  private userEmitted: boolean = false;
  private ready: boolean = false;

  public analytics: 'enabled' | 'disabled' | 'waiting' = 'waiting';
  constructor() {
    this.unleash.on("ready", () => {
      console.log("UNLEASH ready");
      this.ready = true;
    });

    this.unleash.on("update", () => {
      console.log("UNLEASH update");
      if (this.ready) {
        this.analytics = this.isEnabled(FeatureFlags.DISABLE_ANALYTICS) ? 'disabled' : 'enabled';
      }
    });
  }

  start(): void {
    this.unleash.start();
  }

  stop(): void {
    this.unleash.stop();
  }

  updateContext(contextObj: any): void {
    this.unleash.updateContext(contextObj);
  }

  isEnabled(feature: string): boolean {
    return this.unleash.isEnabled(feature);
  }

  isUserEmitted(): boolean {
    return this.userEmitted;
  }

  emitUser(user: any): void {
    const capabilities: any = {};
    for (const key in user.OperatorCapability) {
      console.log(key);
      capabilities[`capability_${key}`] = user.OperatorCapability[key];
    }

    const _user = {
      ...user,
      ...capabilities,
      userId: user.id,
      employersId: user.Teams[0].employers_id,
      employerName: user.employer.name,
      hostName: environment.baseUrl,
    };

    console.log("UNLEASH emitUser", _user);
    // add userId, operator capabilities
    this.updateContext(_user);
    this.userEmitted = true;
  }
}
